module.exports = __webpack_public_path__ + "static/media/img-1.ad03a873.png";